import { ApiOnWidgetFetchDataEpic } from './ApiOnWidgetFetchDataEpic';

export const rootApiEpics = [ApiOnWidgetFetchDataEpic];
